module.exports = __webpack_public_path__ + "img/feature-jobs.55ec1dde6bbe09a77cf393efa8ec42d4.png";